import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const USER_URL = APIURL+"/user/";
export const DASHBOARD_URL = APIURL+"/dashboard";

export function createUser(user) {
	const result = axios.post(`${USER_URL}create`, user);
	return result
}

export function getDashboardRecord() {
	const result = axios.get(`${DASHBOARD_URL}`);
	return result
}

// READ
export function getAllUsers() {
	return axios.get(USER_URL);
}

export function getUserById(userId) {
	const result = axios.get(`${USER_URL}find/${userId}`);
	return result;
}

export function findUsers(queryParams) {
  const result = axios.post(`${USER_URL}find`, { queryParams });
  return result;
}

export function updateUser(user) {
  return axios.post(`${USER_URL}update/${user.id}`, { user });
}

export function updateRecordForUser(id,name,email) {
  return axios.post(`${USER_URL}updateRecordForUser`, { id, name, email });
}

// UPDATE Status
export function updateStatusForUsers(ids, status) {
  return axios.post(`${USER_URL}updateStatusForUsers`, {
    ids,
    status
  });
}
// UPDATE single Status
export function updateStatusForUser(id, status) {
  return axios.post(`${USER_URL}updateStatusForUser`, {
    id,
    status
  });
}

// DELETE => delete the user from the server
export function deleteUser(id) {
 return axios.post(`${USER_URL}delete`, { id });
}

// DELETE Users by ids
export function deleteUsers(ids) {
  return axios.post(`${USER_URL}deleteUsers`, { ids });
}

export function sendCustomEmail(userid, email, subject, message) {
  return axios.post(`${USER_URL}sendEmail`, { userid, email, subject, message });
}

export function updateGracePeriodForUser(userid, grace_period_start, grace_period_end) {
  return axios.post(`${USER_URL}updateGracePeriod`, { userid, grace_period_start, grace_period_end });
}

export function updateBusinessLimitForUser(userid, business_limit) {
  return axios.post(`${USER_URL}updateBusinessLimit`, { userid, business_limit });
}

export function changeMyPassword(newPassword) {
  return axios.post(`${APIURL}/change-password`, { newPassword });
}

